const AgentPermissionOptions = (list) => {
  const options = [
    {
      key: "PORTAL",
      title: "PORTAL",
      value: "PORTAL",
    },
    {
      key: "TMS",
      title: "TMS",
      value: "TMS",
    },
    {
      key: "FINANCE",
      title: "FINANCE",
      value: "FINANCE",
    },
    {
      key: "OPERATION",
      title: "OPERATION",
      value: "OPERATION",
    },
    {
      key: "OPERATION_ADMIN",
      title: "OPERATION_ADMIN",
      value: "OPERATION_ADMIN",
    },
    {
      key: "SALES",
      title: "SALES",
      value: "SALES",
    },
    {
      key: "SALES_ADMIN",
      title: "SALES_ADMIN",
      value: "SALES_ADMIN",
    },
    {
      key: "OPEN_API",
      title: "OPEN_API",
      value: "OPEN_API",
    },
    {
      key: "ONBOARDING",
      title: "ONBOARDING",
      value: "ONBOARDING",
    },
    {
      key: "FINANCE_ONBOARDING",
      title: "FINANCE_ONBOARDING",
      value: "FINANCE_ONBOARDING",
    },
    {
      key: "POREXCLUSIVE_SALES_ONBOARDINGTAL",
      title: "EXCLUSIVE_SALES_ONBOARDING",
      value: "EXCLUSIVE_SALES_ONBOARDING",
    },
    {
      key: "CHONGHING_ONBOARDING",
      title: "CHONGHING_ONBOARDING",
      value: "CHONGHING_ONBOARDING",
    },
    {
      key: "COMPLIANCE",
      title: "COMPLIANCE",
      value: "COMPLIANCE",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AgentPermissionOptions;
